import { getIsMobile } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { PagePriv } from '../../../../types/pagePrivileges';
import { canPerformPageAction } from '../../../selectors/groups';
import {
  getInstalledModuleIds,
  getInstallableModuleTypes,
  getIsInstallingModule,
  getCurrentlyInstalledModulePostion,
} from '../../../selectors/layout';
import { getModuleType } from '../../../selectors/modules';

import { moveModule, addModule, removeModule } from '../../../actions/layout';

import { Props } from './Zone';

type StateProps = Pick<
  Props,
  | 'installedComponents'
  | 'installedModuleIds'
  | 'installableModuleTypes'
  | 'isCurrentUserProfileOwner'
  | 'isAuthorizedToAddModule'
  | 'isAuthorizedToMoveModule'
  | 'isMobile'
  | 'profileOwnerUser'
>;

type DispatchProps = Pick<Props, 'removeModule' | 'addModule' | 'moveModule'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => {
  const installedModuleIds = getInstalledModuleIds(
    state,
    props.section,
    props.type
  );
  const { mapModuleTypeToWidgetComponent } = props;
  // Filter out modules that require a feature
  const componentClasses = Object.keys(mapModuleTypeToWidgetComponent).reduce(
    (result, key) => {
      result[key] = mapModuleTypeToWidgetComponent[key];
      return result;
    },
    {}
  );

  const installedComponents = installedModuleIds
    .map(moduleId => ({
      moduleId,
      ComponentClass: componentClasses[getModuleType(state, moduleId)],
    }))
    .filter(module => module.ComponentClass);

  const installableModuleTypes = getInstallableModuleTypes(
    state,
    props.section,
    props.type
  );

  return {
    isMobile: getIsMobile(state),
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    isInstallingModule: getIsInstallingModule(state, props.section, props.type),
    isAuthorizedToAddModule: canPerformPageAction(state, PagePriv.ADD_MODULE),
    isAuthorizedToMoveModule: canPerformPageAction(state, PagePriv.MOVE_MODULE),
    currentlyInstalledModulePostion: getCurrentlyInstalledModulePostion(
      state,
      props.section,
      props.type
    ),
    profileOwnerUser: getProfileOwnerUser(state),
    installedComponents,
    installedModuleIds,
    installableModuleTypes,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => {
  const { section, type: zone } = ownProps;

  return {
    removeModule: moduleId => () =>
      section && dispatch(removeModule({ section, zone, moduleId })),
    addModule: (moduleType, position) =>
      section && dispatch(addModule({ section, zone, moduleType, position })),
    moveModule: (moduleId, position) => () => {
      dispatch(moveModule({ section, zone, moduleId, position }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
